__turbopack_context__.v({
  "error": "input-module__wBiG9q__error",
  "error_icon": "input-module__wBiG9q__error_icon",
  "error_message": "input-module__wBiG9q__error_message",
  "input": "input-module__wBiG9q__input",
  "input_field": "input-module__wBiG9q__input_field",
  "input_field_no_borders": "input-module__wBiG9q__input_field_no_borders",
  "input_header": "input-module__wBiG9q__input_header",
  "input_required": "input-module__wBiG9q__input_required",
  "input_text_area": "input-module__wBiG9q__input_text_area",
  "input_title": "input-module__wBiG9q__input_title",
});
